'use client';

import Image from 'next/image';

export default function CopyTripButtonBottomBar({ onClickCopyTrip }: { onClickCopyTrip: () => void }) {
  return (
    <div
      className='max-w-[30rem] fixed bottom-0 z-10 w-full bg-white h-100pxr rounded-t-16pxr px-20pxr pt-16pxr pb-34pxr'
      style={{ boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.08)' }}
    >
      <div className='relative w-full'>
        <button
          className='px-16pxr py-14pxr bg-[#3177FF] rounded-8pxr flex items-center justify-center text-white w-full button-16-m'
          onClick={() => onClickCopyTrip()}
        >
          일정표 복사
        </button>
        <Image
          src='https://hoolzzuk-public-images.s3.ap-northeast-2.amazonaws.com/duplicated_trip_left_tip.png'
          alt='tooltip'
          className='absolute z-10 animate-bounce bottom-50pxr'
          width={220}
          height={39}
          quality={100}
        />
      </div>
    </div>
  );
}
